import React from "react";
import ButtonPrimary from "../ButtonPrimary";
import Link from "../Link";
import { FiX } from "react-icons/fi";
import { Container, Modal, Header, Content, Footer } from "./styles";

export default function Alert({
  visible,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  hideCloseButton,
}) {
  if (!visible) {
    return null;
  }

  return (
    <Container>
      <Modal>
        <Header>
          {!hideCloseButton && (
            <button onClick={onCancel}>
              <FiX size={24} style={{ color: "var(--neutral-900)" }} />
            </button>
          )}
          <h1>{title}</h1>
        </Header>

        <Content>{message}</Content>

        <Footer>
          <ButtonPrimary text={confirmText} onClick={onConfirm} />
          {cancelText && <Link text={cancelText} action={onCancel} />}
        </Footer>
      </Modal>
    </Container>
  );
}
